import { render } from "./screenController.vue?vue&type=template&id=4d506fd4&scoped=true"
import script from "./screenController.vue?vue&type=script&lang=js"
export * from "./screenController.vue?vue&type=script&lang=js"

import "./screenController.vue?vue&type=style&index=0&id=4d506fd4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d506fd4"]])

export default __exports__